import { useEffect, useState } from "react";
import { GridColDef, GridRowModel } from "@mui/x-data-grid";
import { CompanySubscription } from "../../../__generated__/graphql";
import { TablePaginated, Header, DateCell, TableStandard } from "ui";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { GET_COMPANY_SUBSCRIPTIONS } from "../../../features/graphql/query/company";
import usePersonStore from "../../store/personStore";

interface SubscriptionTableProps {
    subscriptions: CompanySubscription[]
}
const TABLE_COLUMNS: GridColDef[] = [
    {
        field: "description", headerName: "Type", flex: 2, sortable: true, resizable: false,
        renderCell: ({ value }) => {
            return value ? <div>{value}</div> : ""
        }
    },
    {
        field: "startDate", headerName: "Start Date", flex: 1, sortable: true, resizable: false,
        renderCell: ({ value }) => {
            return value ? <DateCell value={value.toString()} type="" /> : ""
        }
    },
    {
        field: "endDate", headerName: "End Date", flex: 1, sortable: true, resizable: false,
        renderCell: ({ value }) => {
            return value ? <DateCell value={value.toString()} type="subscription" /> : ""
        }
    },
    { field: "status", headerName: "Status", flex: 1, resizable: false }
]
const flattenSubscriptions = (data: any) => {
    const descriptionTrimmed = data.node.subscription.description.split(" ").slice(0, -1).join(" ");
    return {
        startDate: data.node.startDate,
        endDate: data.node.endDate,
        status: data.node.status,
        name: data.node.subscription.name,
        description: descriptionTrimmed,
        id: data.node.id,
        ...data.node
    }
}
export function SubscriptionTable({ subscriptions }: SubscriptionTableProps) {

    const companyId = usePersonStore(state => state.company.id)
    const { loading, data } = useQuery(GET_COMPANY_SUBSCRIPTIONS, {
        notifyOnNetworkStatusChange: true,
        variables: {
            companyId: companyId,
            query: "",
            first: 100
        }
    })
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[]
    }>({
        columns: [],
        rows: []
    })
    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...TABLE_COLUMNS]
            const rows = data?.companySubscriptions?.edges?.map(flattenSubscriptions) ?? []
            return {
                ...prevState,
                columns,
                rows
            }
        })
    }, [subscriptions, data, loading])

    return (
        <TableStandard
            loading={loading}
            renderToolbar={() => (
                <Header
                    title="Subscriptions"
                />
            )}
            rows={pageTableState.rows}
            columns={pageTableState.columns}
            pageSize={6}
            // pageInfo={data?.companySubscriptions?.pageInfo}
            // totalRows={data?.companySubscriptions?.totalCount}
            disableBoxShadow
            getRowClassName={(params) => params.row.status === "Active" ? "Active" : "Expired"}
        />
    )
}